import { IGetAvailableMultiOffersRequestV2 } from '../../repositories/mortgage-broker-calculator/entities/get_avaiable_multi_offers_v2/GetAvailableMultiOffersRequestV2';
import { ICalculatorMcfValues } from '../../types/features';

/**
 * Собирает объект запроса getOfferListingV2 из значений калькулятора.
 * Используется и на node (fetchOffers), и на клиенте (useGetMappedOffers),
 * чтобы ключ кэша RTK Query совпадал и не было повторного запроса при гидрации.
 */
export const buildGetOfferListingRequest = (parameters: ICalculatorMcfValues): IGetAvailableMultiOffersRequestV2 => {
  const regionIdValue = parameters.regionId != null && parameters.regionId !== '' ? Number(parameters.regionId) : null;
  const regionId = regionIdValue != null && !isNaN(regionIdValue) && regionIdValue > 0 ? regionIdValue : 1;

  return {
    regionId,
    loanTermYears: Number(parameters.loanTerm),
    objectCost: parameters.objectCost,
    downPayment: parameters.downPayment,
    incomeConfirmation: parameters.incomeConfirm,
    realEstateType: parameters.realEstateType,
    objectType: parameters.objectType,
    benefitProgram: parameters.benefitProgram,
    employmentType: parameters.typeOfEmployment,
    payrollBankId: Number(parameters.payrollBank),
  } as unknown as IGetAvailableMultiOffersRequestV2;
};
